import { ChevronRightIcon } from '@heroicons/react/20/solid'
import cx from 'classix'
import React from 'react'

type Props = {
  className?: string
  link: string
  text: string
}

export default function NavButtonLink({ className, link, text }: Props) {
  return (
    <a
      href={link}
      className={cx(
        'py-2 px-6 gap-2 font-bold flex items-center bg-transparent rounded-xl hover:underline border-white border',
        className
      )}
    >
      <span>{text}</span>
      <ChevronRightIcon className='h-5 w-5' />
    </a>
  )
}
